import Width from '../style-helper/Width';

export const focusHighlight = (highlightColor, spreadRadius = 1) => ({
  borderColor: highlightColor,
  boxShadow: `0 0 0 ${spreadRadius}px ${highlightColor}`,
});

export default {
  fontWeight: props => props.theme.base.fontWeight,
  letterSpacing: props => props.theme.base.letterSpacing,
  position: 'relative',
  display: 'inline-block',
  width: Width.full,
  height: 40,
  margin: 0,
  transition: 'border linear 0.2s',
  verticalAlign: 'middle',
  color: '#333',
  border: '1px solid #8c8c8c',
  borderRadius: 4,
  appearance: 'none',
  
  '&:hover': {
    borderColor: '#333',
  },
  
  '&:focus': {
    extend: props => ({
      ...focusHighlight((props.isUsingArtemisStyles && props.theme.formgroup?.general?.border?.focus)
        ? props.theme.formgroup.general.border.focus.color
        : props.theme.focusHighlightColour),
    }),
    backgroundColor: props => props.theme.inputFocusBackgroundColour,
  },

  '&.error-block, &.error-block-v2': {
    marginTop: 0,
    color: props => props.theme.base.color,
    borderColor: '#c42c21',
    '&:focus': {
      extend: ({
        ...focusHighlight('#c42c21'),
      }),
    },
  },
};
